// PolygonInfo.tsx
import React from "react";
import { Paper, Stack, Title, Code, ScrollArea } from "@mantine/core";
import { useAppSelector } from "../../app/hooks";
import { selectDebugFootprintPolygons } from "./three3Selectors";

export const PolygonInfo: React.FC = () => {
  const footprintItems = useAppSelector(selectDebugFootprintPolygons);

  return (
    <Paper h="100%" w="100%" shadow="sm" p="md" withBorder>
      <Title order={4}>Computed Polygon (JSON)</Title>
      <ScrollArea h="calc(100% - 32px)" mt="sm" type="auto" scrollbarSize={8}>
        {footprintItems ? (
          <Code block>{JSON.stringify(footprintItems, null, 2)}</Code>
        ) : (
          <Code>Ingen polygondata tilgjengelig.</Code>
        )}
      </ScrollArea>
    </Paper>
  );
};
